// Generated by Melange


const audio = new Audio();

audio.crossOrigin = "anonymous";

const replayGainValue = {
  contents: undefined
};

const skipping = {
  contents: false
};

const value = {
  contents: undefined
};

export {
  audio,
  replayGainValue,
  skipping,
  value,
}
/* audio Not a pure module */
